import React, { Component } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import {
  StyledBasicExpansionPanel,
  StyledBasicExpansionPanelSummary,
} from "../../shared/ExpansionPanels/ExpansionPanel.js";
import styles from "./CustomerReservation.module.scss";
import crStyles from "./crStyles.js";
import { Link } from "react-router-dom";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import NavigateNext from "@material-ui/icons/NavigateNext";
import NavigateBefore from "@material-ui/icons/NavigateBefore";
import { withTranslation } from "react-i18next";
import HasPermissionTo from "../../common/HasPermissionTo";
import SortingIcon from "../../shared/sortingIcon/SortingIcon";
import TitleCase from "../../utils/TitleCase";
import CustomerReservationsClient from "../../shared/clients/CustomerReservationsClient";
import UiDateUtils from "../../utils/UiDateUtils";
import LowerCaseText from "../../utils/LowerCaseText";
import UpperCaseText from "../../utils/UpperCaseText";
import { PURCHASE_REQUEST_STATUS } from "../../common/Constants";
import { AGENT, DEALER, NULL_OR_UNDEFINED } from "../../utils/EmpUtil";

class CustomerReservationTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortDir: undefined,
      sortKey: undefined,
      sortByString: undefined,
      iconUp: true,
      loading: false,
    };
    this.statusMap = {
      CREATED: "created",
      RESERVATION_FAILED: "created",
      ORDER_RESERVED: "created",
      CONTRACT_REQUESTED: "confirmed",
      CONTRACT_REQUEST_FAILED: "confirmed",
      CONTRACT_FAILED: "confirmed",
      CONTRACT_CANCEL_REQUESTED: "ordered",
      CONTRACT_CANCEL_REQUEST_FAILED: "ordered",
      RESERVATION_CANCELLED: "cancelled",
      DEALER_CANCELLED: "cancelled",
      CONTRACT_CANCELLED: "cancelled",
      CONVERTED_TO_OFFLINE: "amended",
      AMENDED: "amended",
      ORDER_CONTRACTED: "contracted",
      ORDER_CONFIRMED: "submitted",
      CONTRACT_CANCEL_FAILED: "ordered",
      RESERVATION_CANCELLATION_FAILED: "contracted",
      AMEND_CONTRACT_REQUEST_FAILED: "contracted",
      AMEND_CONTRACT_CANCEL_REQUEST_FAILED: "contracted",
      ORDERED: "ordered",
      COMPLETED: "completed",
      ORDER_CANCELLED: "cancelled",
    };

    this.handlePrevious = this.handlePrevious.bind(this);
    this.handleNext = this.handleNext.bind(this);

    this.herculesCanViewDealerType =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "herculesCanViewDealerType"
      );
  }
  handlePrevious() {
    this.props.hideOrShow(true);
    this.setState({ loading: true });
    CustomerReservationsClient.getCustomerReservations(
      this.props.user.token,
      this.props.commonDealerId.split("|").join("%7C"),
      this.props.currentPage - 2,
      this.props.lang,
      this.state.sortByString,
      this.props.user.market,
      this.props.selectedTab
    )
      .then((result) => {
        this.updateState(
          result.reservations,
          result.pagination.numberOfPages,
          result.pagination.totalNumberOfResults,
          this.props.currentPage - 1
        );
      })
      .catch()
      .finally(() => {
        this.props.hideOrShow(false);
        this.setState({ loading: false });
      });
  }

  handleNext() {
    this.props.hideOrShow(true);
    this.setState({ loading: true });
    CustomerReservationsClient.getCustomerReservations(
      this.props.user.token,
      this.props.commonDealerId.split("|").join("%7C"),
      this.props.currentPage,
      this.props.lang,
      this.state.sortByString,
      this.props.user.market,
      this.props.selectedTab
    )
      .then((result) => {
        this.updateState(
          result.reservations,
          result.pagination.numberOfPages,
          result.pagination.totalNumberOfResults,
          this.props.currentPage + 1
        );
      })
      .catch()
      .finally(() => {
        this.props.hideOrShow(false);
        this.setState({ loading: false });
      });
  }

  handleSort(sortKey, newDirection, sortByString) {
    this.props.hideOrShow(true);
    this.setState({ sortKey, sortDir: newDirection, sortByString });

    CustomerReservationsClient.getCustomerReservations(
      this.props.user.token,
      this.props.commonDealerId.split("|").join("%7C"),
      this.props.currentPage - 1,
      this.props.lang,
      sortByString,
      this.props.user.market,
      this.props.selectedTab
    )
      .then((result) => {
        this.updateState(
          result.reservations,
          result.pagination.numberOfPages,
          result.pagination.totalNumberOfResults,
          this.props.currentPage
        );
      })
      .catch()
      .finally(() => {
        this.props.hideOrShow(false);
        this.setState({ loading: false });
      });
  }

  getSortString(sortKey) {
    this.setState({ loading: true });
    let newDirection = "DSC";
    if (sortKey === this.state.sortKey) {
      newDirection = this.state.sortDir === "ASC" ? "DSC" : "ASC";
    }

    if (sortKey === "orderDate") {
      newDirection === "ASC"
        ? this.handleSort(sortKey, newDirection, "byDateAsc")
        : this.handleSort(sortKey, newDirection, "byDate");
    } else if (sortKey === "id") {
      newDirection === "ASC"
        ? this.handleSort(sortKey, newDirection, "byOrderNumber")
        : this.handleSort(sortKey, newDirection, "byOrderNumberDesc");
    }
  }

  updateState(reservations, numPages, numResults, newPage) {
    reservations.forEach((reservation) => {
      reservation.orderType =
        reservation.orderType === "pre-order"
          ? this.props.t("CustomerReservations.preOrder")
          : reservation.orderType;
    });

    this.props.updateTables(
      reservations,
      numPages,
      numResults,
      this.props.commonDealerId,
      newPage
    );
    this.loading = false;
  }

  determineRegionalId() {
    const filteredDealer =
      this.props.user.dealerGroup &&
      this.props.user.dealerGroup.filter(
        (dealer) => dealer.commonId === this.props.commonDealerId
      );
    if (filteredDealer && filteredDealer.length === 1)
      return filteredDealer[0].regionalId;
  }

  flipIcon() {
    const current = this.state.iconUp;
    this.setState({ iconUp: !current });
  }

  resolveInlineStyle(status) {
    switch (status) {
      case "created":
      case "contracted":
      case "confirmed":
      case "ordered":
      case "completed":
        return crStyles.confirmedStatus;
      case "cancelled":
        return crStyles.cancelledStatus;
      case "amended":
        return crStyles.amendedStatus;
      default:
        return crStyles.commonStatusStyle;
    }
  }

  resolvePurchaseStyle(status) {
    const statusCaps = status ? UpperCaseText(status) : "";
    switch (statusCaps) {
      case PURCHASE_REQUEST_STATUS.ACCEPTED:
        return crStyles.confirmedStatus;
      case PURCHASE_REQUEST_STATUS.CANCELLED:
        return crStyles.cancelledStatus;
      default:
        return crStyles.amendedStatus;
    }
  }

  getSpecs(reservation) {
    return (
      reservation.specSummary &&
      reservation.specSummary.filter(Boolean).join(" / ")
    );
  }

  getOrderCancellationDate = (order) => {
    let cancelledDate = "";
    if (order && order.euCancellationDate) {
      cancelledDate = order.euCancellationDate;
    }

    return UiDateUtils.formatYYYYMMDDToEUWithoutTime(cancelledDate);
  };

  translateOrderType(reservation) {
    let dealerType = "";
    if (this.herculesCanViewDealerType) {
      if (NULL_OR_UNDEFINED(reservation.dealerType)) {
        dealerType = this.props.t("CustomerOrderDetails.dealer");
      } else {
        switch (reservation.dealerType) {
          case DEALER:
            dealerType = this.props.t("CustomerOrderDetails.dealer");
            break;
          case AGENT:
            dealerType = this.props.t("CustomerOrderDetails.agent");
            break;
          default:
            dealerType = this.props.t("CustomerOrderDetails.dealer");
        }
      }
    }
    //Purchase Request
    if (reservation.purchaseType || reservation.purchaseRequestDate) {
      return `${dealerType} ${this.props.t(
        "CustomerReservations.purchaseRequest"
      )}`;
    }
    //Order
    else if (LowerCaseText(reservation.orderType).includes("order")) {
      return `${dealerType} ${this.props.t("CustomerReservations.order")}`;
    } else return `${dealerType} ${reservation.orderType}`;
  }

  render() {
    function getTableHeader(style, divStyle, column) {
      return this.props.fromCrc ? (
        <TableCell id={column + this.props.commonDealerId} style={style}>
          <div className={divStyle}>
            {this.props.t("CustomerReservations." + column)}
          </div>
        </TableCell>
      ) : (
        <TableCell
          data-testid={column + this.props.commonDealerId}
          style={style}
          onClick={() =>
            !this.props.searchEnabled && this.getSortString(column)
          }
        >
          <div className={divStyle} data-testid="sort">
            {this.props.t("CustomerReservations." + column)}
            <SortingIcon
              hide={this.props.searchEnabled}
              currentKey={column}
              sortKey={this.state.sortKey}
              sortDirection={this.state.sortDir}
            />
          </div>
        </TableCell>
      );
    }

    return (
      <div key={this.props.index} className={styles.tablePadding}>
        <StyledBasicExpansionPanel
          styles={crStyles.expansionPanel}
          defaultExpanded={true}
          style={{ boxShadow: "none" }}
          onChange={() => this.flipIcon()}
        >
          <StyledBasicExpansionPanelSummary
            style={crStyles.headerBarNeutral}
            id="exp"
          >
            <div className={styles.headerBar}>
              <Grid container>
                <Grid item md={5} style={crStyles.gridItem}>
                  <HasPermissionTo
                    perform={["reservationsRegionalId:view"]}
                    condition={
                      this.props.user.userType === "dealer" ||
                      this.props.fromNscDealerSearch
                    }
                    permissions={this.props.user.permissions.rolePermissions}
                    render={() => (
                      <span className={styles.boldHeader}>
                        {this.determineRegionalId() + "  |  "}
                      </span>
                    )}
                  />

                  {this.props.reservations[0].dealerName && (
                    <span className={styles.boldHeader}>
                      &nbsp;
                      {UpperCaseText(this.props.reservations[0].dealerName)}
                    </span>
                  )}
                </Grid>
                <Grid item md={2} style={crStyles.gridItems}>
                  <span className={styles.boldHeader}>
                    {this.props.totalNumberOfResults}{" "}
                    {this.props.totalNumberOfResults === 1
                      ? this.props.t("CustomerReservations.item")
                      : this.props.t("CustomerReservations.items")}
                  </span>
                </Grid>
                <Grid item md={3} />
                <Grid item md={2} style={crStyles.dropdown}>
                  {this.state.iconUp ? (
                    <ExpandLessIcon id="less" />
                  ) : (
                    <ExpandMoreIcon id="more" />
                  )}
                </Grid>
              </Grid>
            </div>
            <br />
          </StyledBasicExpansionPanelSummary>
          <div className={styles.bottomBorder}></div>
          <Table id="newTable" key={this.props.index}>
            <TableHead>
              <TableRow
                style={crStyles.headers}
                className={styles.orderTableHeaderRow}
              >
                <TableCell
                  data-testid={"orderType" + this.props.commonDealerId}
                  style={crStyles.orderTypeHeader}
                >
                  <div className={styles.alignStart}>
                    {this.props.t("CustomerReservations.orderType")}
                  </div>
                </TableCell>
                {getTableHeader.call(
                  this,
                  crStyles.idHeader,
                  styles.alignCenter,
                  "id",
                  1
                )}
                {getTableHeader.call(
                  this,
                  crStyles.dateHeader,
                  styles.alignCenter,
                  "orderDate",
                  2
                )}
                <TableCell
                  data-testid={"specs" + this.props.commonDealerId}
                  style={crStyles.specsHeader}
                >
                  <div className={styles.alignStart}>
                    {this.props.t("CustomerReservations.specs")}
                  </div>
                </TableCell>
                <TableCell
                  data-testid={"status" + this.props.commonDealerId}
                  style={crStyles.statusHeader}
                >
                  <div className={styles.alignCenter}>
                    {this.props.t("CustomerReservations.status")}
                  </div>
                </TableCell>
                <TableCell style={crStyles.emptyHeader} />
              </TableRow>
            </TableHead>
            <TableBody
              data-testid="reservationTable"
              className={styles.tableBody}
            >
              {this.props.reservations.map((reservation, index) => (
                <TableRow
                  className="pagePaddingLeft pagePaddingRight"
                  id={"row" + index}
                  key={index}
                >
                  <TableCell style={crStyles.orderType}>
                    {this.translateOrderType(reservation)}
                  </TableCell>
                  <TableCell style={crStyles.orderId}>
                    {reservation.id}
                  </TableCell>
                  <TableCell style={crStyles.date}>
                    {UiDateUtils.formattedDate(reservation.date)}
                  </TableCell>
                  <TableCell style={crStyles.specs}>
                    <div className={styles.specsContainer}>
                      <div className={styles.nameplate}>
                        {reservation.nameplate}
                      </div>
                      <span className={styles.specs}>
                        {this.getSpecs(reservation)}
                      </span>
                    </div>
                  </TableCell>
                  <TableCell
                    style={
                      reservation.purchaseRequestStatus
                        ? this.resolvePurchaseStyle(
                            reservation.purchaseRequestStatus
                          )
                        : this.resolveInlineStyle(
                            this.statusMap[reservation.status]
                          )
                    }
                  >
                    <span>
                      {reservation.purchaseRequestStatus
                        ? TitleCase(reservation.purchaseRequestStatus)
                        : TitleCase(reservation.businessStatus)}
                    </span>
                    {this.statusMap[reservation.status] === "cancelled" && (
                      <>
                        <br />
                        <span>
                          {this.getOrderCancellationDate(reservation)}
                        </span>
                      </>
                    )}
                  </TableCell>
                  <TableCell style={crStyles.view}>
                    <HasPermissionTo
                      perform={["orderDetails:view"]}
                      permissions={this.props.user.permissions.rolePermissions}
                      condition={!this.props.fromNscDealerSearch}
                      render={() => (
                        <Button
                          className={styles.tableLink}
                          data-testid="crcView"
                          style={crStyles.viewButton}
                          id={reservation.id}
                          onClick={() =>
                            this.props.showOrderDetails(
                              reservation.dealerId,
                              reservation.id,
                              true
                            )
                          }
                        >
                          {this.props.t("CustomerReservations.view")}
                          <ChevronRightIcon style={crStyles.viewIcon} />{" "}
                        </Button>
                      )}
                      noRender={() => (
                        <Link
                          id="reservationLink"
                          to={`/dealer/${reservation.dealerId}/customer-reservations/order-details/${reservation.id}`}
                          className={styles.tableLink}
                        >
                          {this.props.t("CustomerReservations.view")}
                          <ChevronRightIcon style={crStyles.viewIcon} />
                        </Link>
                      )}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <HasPermissionTo
            perform={["reservationPagination:view"]}
            permissions={this.props.user.permissions.rolePermissions}
            condition={
              !this.props.searchEnabled &&
              (this.props.user.userType === "dealer" ||
                this.props.fromNscDealerSearch)
            }
            render={() => (
              <div className={styles.pagesDiv}>
                <button
                  disabled={this.props.currentPage === 1 || this.state.loading}
                  data-testid="prev"
                  onClick={this.handlePrevious}
                >
                  <NavigateBefore
                    style={
                      this.props.currentPage === 1
                        ? crStyles.arrowDisabled
                        : crStyles.arrowEnabled
                    }
                  />
                </button>
                <div className={styles.pages}>
                  {this.props.currentPage} / {this.props.numberOfPages}
                </div>
                <button
                  disabled={
                    this.props.currentPage === this.props.numberOfPages ||
                    this.state.loading
                  }
                  data-testid="next"
                  onClick={this.handleNext}
                >
                  <NavigateNext
                    style={
                      this.props.currentPage === this.props.numberOfPages
                        ? crStyles.arrowDisabled
                        : crStyles.arrowEnabled
                    }
                  />
                </button>
              </div>
            )}
          />
        </StyledBasicExpansionPanel>
      </div>
    );
  }
}

export default withTranslation("emp")(CustomerReservationTable);
